// Mid-section directions screen (Revising/Editing Part A / Part B — printed
// test pages 59 / 67). Shown BEFORE a question whose workbook `Section
// Directions` marker resolved to a prompt (see sectionDirections.ts). Renders
// only the prompt box in the same style as the module-start directions — the
// caller's live top bar (timer, back, blue forward arrow) stays above it and
// the forward arrow dismisses it. Self-contained KaTeX so callers need no
// extra hooks. Used by both players (legacy Module + AdaptiveModule).
import React, { useEffect, useRef } from 'react';
import renderMathInElement from 'katex/dist/contrib/auto-render.js';

const KATEX_DELIMITERS = [
  { left: '$$', right: '$$', display: true },
  { left: '$', right: '$', display: false },
  { left: '\\(', right: '\\)', display: false },
  { left: '\\[', right: '\\]', display: true },
];

export function SectionDirectionsScreen(props: { prompt: string }): JSX.Element {
  const { prompt } = props;
  const promptRef = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    if (!promptRef.current) return;
    renderMathInElement(promptRef.current, {
      delimiters: KATEX_DELIMITERS,
      trust: true,
    });
  }, [prompt]);
  return (
    <div className="digitalSHSATModule__promptContainer">
      <div className="digitalSHSATModule__promptBox">
        <span ref={promptRef} className="katex">{prompt}</span>
      </div>
    </div>
  );
}
